import {
  ModalTransition as LibModalTransition,
  ModalTransitionProps,
} from "@flaminem/ui-components";

import { useFullScreen } from "src/hooks/useFullScreen";

export const ModalTransition = ({ withPortal, ...props }: ModalTransitionProps) => {
  const { active } = useFullScreen();

  return (
    <LibModalTransition {...props} withPortal={withPortal === undefined ? !active : withPortal} />
  );
};
